module.exports = __webpack_public_path__ + "img/lifestyle-banner.8910449b.jpg";